export default __webpack_public_path__ + "static/media/closeIcon.f7694152.svg";